import React from 'react';
import styles from './index.css';
import { sendCommentFixAddNum } from '../../../../utils/api';
class CommentGuidePopup extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.closeGuide = () => {
            this.props.closeGuide();
        };
    }
    componentDidMount() {
        const { guidInfo } = this.props;
        sendCommentFixAddNum((guidInfo === null || guidInfo === void 0 ? void 0 : guidInfo.countKey) || '');
    }
    render() {
        const { guidInfo } = this.props;
        return (React.createElement("div", { className: styles.popupBox },
            React.createElement("div", { className: styles.popup },
                React.createElement("img", { className: styles.popupPic, src: (guidInfo === null || guidInfo === void 0 ? void 0 : guidInfo.backgroundImage) || '' }),
                React.createElement("img", { className: styles.popupQrcode, src: (guidInfo === null || guidInfo === void 0 ? void 0 : guidInfo.qrcodeImage) || '' }),
                React.createElement("div", { className: styles.popupClose, onClick: this.closeGuide }))));
    }
}
export default CommentGuidePopup;
